import { motion } from "framer-motion";
import { ShoppingBasket } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { rupiah } from "@/lib/format";

export default function FloatingCart() {
  const { count, subtotal, setOpen } = useCart();
  if (count === 0) return null;
  return (
    <motion.button
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="floating-cart-btn"
      onClick={() => setOpen(true)}
      className="md:hidden fixed bottom-4 inset-x-4 z-40 rounded-full bg-orange-500 text-white px-5 py-3.5 shadow-xl shadow-orange-500/40 flex items-center justify-between font-bold text-sm active:scale-95 transition"
    >
      <span className="flex items-center gap-2">
        <ShoppingBasket className="w-5 h-5" />
        {count} item
      </span>
      <span>{rupiah(subtotal)} · Checkout →</span>
    </motion.button>
  );
}
